
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PrimaryRecipientErrorModalTemplate } from 'themes/application/facility-order-new-flow-order-summary/components';
import { PrimaryRecipientErrorModalStore } from '../stores';

@setCurrentView((rootStore, componentProps) => new PrimaryRecipientErrorModalStore(rootStore, componentProps), 'primaryRecipientErrorModalStore')
@observer
class PrimaryRecipientErrorModal extends React.Component {
    render() {
        return <PrimaryRecipientErrorModalTemplate {...this.props} />
    }
}

export default PrimaryRecipientErrorModal;
